<template>
    <div class="modal fade" id="modal-complemento">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Complemento</h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>

                <div class="modal-body">
                    <div class="d-sm-flex justify-content-between">
                        <div class="p-2">
                            <b>ID: </b> {{ complemento.id }}
                        </div>

                        <div class="p-2">
                            <b>Denúncia: </b> {{ complemento.denuncia_id }}
                        </div>

                        <div class="p-2">
                            <b>Data: </b> {{ complemento.created_at | moment("DD/MM/YYYY") }}
                        </div>

                        <div class="p-2">
                            <b>Hora: </b> {{ convert_hor(complemento.created_at) | moment("HH:mm:ss") }}
                        </div>
                    </div>

                    <hr>

                    <div v-if="complemento.anexo_count">
                        <div class="d-sm-flex justfy-content-between">
                            <div class="p-2" v-for="anexo in complemento.anexo" :key="anexo.id">
                                <input type="hidden" v-if="carrega_anexo(anexo)">
                                <button class="btn btn-sm btn-light" @click="view_anexo(anexo)">{{ anexo.nome }}</button>
                            </div>
                        </div>

                        <hr>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label>Complemento</label>
                                <textarea class="form-control form-control-sm" v-model="complemento.complemento" cols="30" rows="12" readonly></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal :attachment="modal_data" name="comp-modal-anexo" />
    </div>
</template>

<script>
    import api   from '@/mixins/api.js'
    import modal from '@/components/Modal/anexo'

    export default {
        name: "modal-complemento",
        props: [ 'complemento' ],
        components: { modal },
        mixins: [ api ],

        data() { return {
            anexos: {},
            modal_data: {},
        }},

		// watch: {
		// 	complemento() { 
		// 		this.get_anexos()
		// 	}
		// },

        methods: {
            async get_anexos() {
                const response = await this.GET("Denuncia", `Anexo?where=complemento_id&id=${this.complemento.id}`)
                if ( response.status == 'success') this.anexos = response.result
            },

			async carrega_anexo(anexo_aux){
				const response = await this.POST("Denuncia/Anexo/pegaArquivo",{ path: anexo_aux.path, tipo: anexo_aux.type})
				anexo_aux.file = response
			},

			convert_hor(payload){
				var nova_hora = new Date(payload);
				nova_hora.setHours(nova_hora.getHours()-3);
				return nova_hora;
			},

            view_anexo(payload) {
                this.modal_data = payload
                $("#comp-modal-anexo").modal()
            },
        },
    }
</script>